import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingCard';

import { cancelBooking } from './utils';

export default function* listenCancel() {
  yield takeEvery(actions.cancel.type, cancelBooking);
}
